import React from "react";
import "../styles/blog3.css";

import { useState } from "react";
import { Link } from "react-router-dom";

const Blog3 = () => {
  const [hover, setHover] = useState(false);

  return (
    <main
      className="main-section"
      style={{ maxWidth: 1200, margin: "120px auto 40px auto", padding: 30 }}
    >
      <Link
        to="/blogs"
        style={{
          background: hover ? "#f96e2a" : "#fff",
          border: "1.5px solid #f96e2a",
          borderRadius: 20,
          padding: "7px 22px",
          color: hover ? "#fff" : "#f96e2a",
          fontWeight: 500,
          marginBottom: 28,
          cursor: "pointer",
          boxShadow: "0 2px 14px #f7c69c15",
          textDecoration: "none",
          display: "inline-block",
          transition: "all 0.18s",
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        ← Back to Blogs
      </Link>
      <section className="blog-article">
        <div className="blog-article-header">
          <img
            className="blog-author-photo"
            src={require("../assets/blogs/nabarun-sen.webp")}
            alt="Nabarun Sen, Director"
          />
          <div className="blog-author-info">
            <span className="blog-author-name">Nabarun Sen</span>
            <span className="blog-author-role">Director, Serenityy</span>
          </div>
        </div>
        <h2 className="blog-article-title">The Glass Floor of Finance </h2>
        <span style={{ fontWeight: 400, fontStyle: "italic" }}>
          A Morning Reflection from the Mountains
        </span>
        <p style={{ fontSize: "0.95rem", opacity: 0.7 }}>
          Posted on 4 July 2025
        </p>
        <p>
          It’s early. Quiet. The kind of quiet you only get in the hills when
          the clouds hang low, and the air feels like a pause button. A cup of
          coffee beside me, sun just cracking through the mist and I’m thinking
          about money. Not markets, not rates. Money, as it lives in people’s
          lives. Because that’s what I’ve seen, again and again: it’s not about
          finance, it’s about feeling.
        </p>
        <h3>Money Isn’t Complicated. But We Are.</h3>
        <p>
          Strip everything down, and money only does two things: it comes in,
          and it goes out. Earning and spending. Saving and investing. That’s
          it.
          <br />
          But how we handle that simple truth—how we react, overthink, delay, or
          jump in too fast—that’s where life happens. That’s where mistakes
          happen. That’s where stories are written.
        </p>
        <h3>The Illusion of Control</h3>
        <p>
          <li>
            From the surface, everything looks smooth. Fancy dashboards. Clean
            apps. Pretty reports.{" "}
          </li>
          <li>
            {" "}
            But just beneath that surface is movement. Emotion. Uncertainty.
            Hopes pinned to numbers.{" "}
          </li>
          <li>
            Decisions made in fear or euphoria. It’s like walking on glass—clear
            and stable, until it isn’t.
          </li>
          <li>
            And when it breaks? You don’t fall a few inches. You fall deep.
            Because money carries weight not just in value, but in meaning.
          </li>
        </p>
        <h3>Why We Trip</h3>
        <p>
          People rarely fall because they aren’t smart. They fall because they
          assumed. Assumed safety. Assumed clarity. Assumed someone else would
          tell them the full story. And sometimes, they weren’t ready to hear
          it. We want comfort more than truth.
          <br /> <br />
          But money doesn’t care what we’re ready for. It simply moves and we
          either move with understanding, or we react with regret.
        </p>
        <h3>The Mirror I Didn’t Expect</h3>
        <p>
          I’m not writing this as an advisor today. I’m writing this as someone
          who’s made those missteps too. Someone who’s let ego get ahead of
          education. I’ve wanted to be right more than I’ve wanted to ask the
          right questions. And I’ve seen what happens when silence wins over
          honesty. When flashy confidence hides fragile understanding.
          <br />
          <br />
          And that’s why I now believe in something simpler and stronger.
        </p>
        <h3>The Real Framework</h3>
        <p>There are only four building blocks to wealth:</p>
        <ul>
          <li>Equity</li>
          <li>Debt</li>
          <li>Real estate</li>
          <li>Commodities</li>
        </ul>
        <p>
          None of them are magic. None of them are evil. They just reflect the
          same old game: risk and return, emotion and endurance.
          <br />
          <br />
          <b>The key?</b> Match them to your goals. Not your friend's goals. Not
          your advisor’s script. Yours.
        </p>
        <h3>Let’s Not Overdo It</h3>
        <p>
          You don’t need a PhD to make your money work. But you do need honesty.
          Your plan should fit your lifestyle. Your returns should fit your risk
          appetite. And your actions should reflect your priorities, not your
          insecurities. Idle money feels safe, but it decays. Impulsive money
          feels bold, but it burns.
          <br />
          <br />
          Somewhere in between is a space of discipline, awareness, and peace.
          That’s the space I want to stay in.
        </p>
        <h3>A Note to Whoever’s Reading This</h3>
        <p>
          You might be 25. Or 60. You might have five properties or be starting
          from scratch. It doesn’t matter. What matters is that you see your
          money clearly. Not emotionally. Not reactively. Clearly. Let’s ask
          better questions. Let’s drop the pretense. Let’s build from truth, not
          trend. Because when you learn, I learn. When you grow, we all rise
          together.
          <br />
          <br />
          This isn’t a blog. This is a mirror. And if it helps even one person
          pause, reset, and move forward smarter, then it was worth writing.
        </p>
      </section>
    </main>
  );
};

export default Blog3;
